import React, { useState } from "react";
import { Download, Check } from "lucide-react";
import { toast } from "sonner";
import { exportDeadStockCSV, track } from "../lib/api";

/**
 * ExportDeadStockButton — triggers a browser download of the full dead-stock
 * list as a Hebrew-compatible UTF-8 CSV (Excel opens it natively).
 *
 * Pass `variant="ghost"` for use inside the home strip, default for the hero.
 */
export default function ExportDeadStockButton({
  variant = "default",
  testId = "export-dead-stock-btn",
}) {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const handleExport = async (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      track("dead_stock_export_click", window.location.pathname, {});
      const { filename, blob } = await exportDeadStockCSV();
      // Trigger browser download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setDone(true);
      toast.success("הקובץ הורד — פתח ב-Excel");
      setTimeout(() => setDone(false), 2500);
    } catch (err) {
      toast.error("שגיאה בייצוא: " + (err?.response?.data?.detail || err.message));
    } finally {
      setBusy(false);
    }
  };

  const base = "inline-flex items-center gap-1.5 text-xs transition-all disabled:opacity-50 disabled:cursor-not-allowed";
  const styles =
    variant === "ghost"
      ? "text-zinc-400 hover:text-foreground border border-border hover:border-zinc-600 px-2.5 py-1 rounded-md"
      : "text-foreground bg-primary/10 hover:bg-primary/15 border border-primary/30 hover:border-primary/50 px-3 py-1.5 rounded-md font-medium";

  return (
    <button
      type="button"
      onClick={handleExport}
      disabled={busy}
      className={`${base} ${styles}`}
      data-testid={testId}
      title="ייצא רשימה מלאה ל-Excel"
    >
      {done ? <Check className="w-3 h-3" /> : <Download className={`w-3 h-3 ${busy ? "animate-pulse" : ""}`} />}
      <span>{busy ? "מייצא..." : done ? "הורד!" : "ייצא ל-Excel"}</span>
    </button>
  );
}
